import { fade } from "../utils/color.js";
export default function createSwitchPalette(theme, current, base) {
    return {
        switch: {
            backgroundColor: undefined,
            borderColor: base.gray[500],
            boxShadow: undefined,
            hover: {
                backgroundColor: current[50],
                borderColor: current[200],
            },
            checked: {
                backgroundColor: current[500],
                borderColor: current[500],
                hover: {
                    backgroundColor: current[400],
                    borderColor: current[400],
                },
                active: {
                    backgroundColor: current[600],
                    borderColor: current[600],
                },
            },
            focus: {
                borderColor: fade(current[500], 0.6),
                boxShadowColor: current[500],
            },
            disabled: {
                color: base.text[300],
                backgroundColor: theme.scheme === "light" ? base.gray[100] : base.gray[25],
                borderColor: theme.scheme === "light" ? base.gray[400] : base.gray[100],
                checked: {
                    backgroundColor: theme.scheme === "light" ? base.gray[400] : base.gray[100],
                    borderColor: theme.scheme === "light" ? base.gray[400] : base.gray[100],
                },
            },
            track: {
                backgroundColor: theme.scheme === "light" ? base.gray[200] : base.gray[50],
                checked: {
                    backgroundColor: theme.scheme === "light" ? current[50] : current[200],
                    disabled: {
                        backgroundColor: theme.scheme === "light" ? base.gray[100] : base.gray[25],
                    },
                },
                disabled: {
                    backgroundColor: theme.scheme === "light" ? base.gray[100] : base.gray[25],
                },
            },
            thumb: {
                backgroundColor: theme.scheme === "light" ? base.background : base.gray[200],
                boxShadowColor: current[500],
                checked: {
                    backgroundColor: current[500],
                    disabled: {
                        backgroundColor: theme.scheme === "light" ? base.gray[400] : base.gray[100],
                    },
                },
                disabled: {
                    backgroundColor: theme.scheme === "light" ? base.gray[400] : base.gray[100],
                },
            },
            icon: {
                color: base.background,
                strokeColor: base.background,
            },
        },
    };
}
//# sourceMappingURL=switch.js.map